// src/components/DeviceManagement/DeviceCard.js
import React from 'react';
import PropTypes from 'prop-types';
import './DeviceCard.css';

/**
 * Individual device card component
 * 
 * Displays a single device in the device selector dropdown
 * 
 * @param {Object} props - Component props
 * @param {Object} props.device - Device object
 * @param {boolean} props.isSelected - Whether this device is currently selected
 * @param {Function} props.onSelect - Callback when device is selected
 */
const DeviceCard = ({ device, isSelected, onSelect }) => {
  const displayName = device.displayName || 'Unnamed Device';
  const serialNumber = device.serialNumber || 'No SN';

  return (
    <option 
      value={device.deviceId}
      className={`device-card-option ${isSelected ? 'selected' : ''}`}
    >
      {`${displayName} (${serialNumber})`}
    </option>
  );
};

DeviceCard.propTypes = {
  device: PropTypes.shape({
    deviceId: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    serialNumber: PropTypes.string,
  }).isRequired,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
};

DeviceCard.defaultProps = {
  isSelected: false,
  onSelect: () => {},
};

export default DeviceCard;
